import { render, staticRenderFns } from "./OtrasDiscograficas.vue?vue&type=template&id=5d2f21e9&scoped=true&"
import script from "./OtrasDiscograficas.vue?vue&type=script&lang=js&"
export * from "./OtrasDiscograficas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f21e9",
  null
  
)

export default component.exports